var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHastag = function SvgIconHastag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M7.562 1.691a.563.563 0 0 1 .497.621l-1.5 13.5a.563.563 0 0 1-1.118-.124l1.5-13.5a.563.563 0 0 1 .621-.497M12.062 1.691a.563.563 0 0 1 .497.621l-1.5 13.5a.563.563 0 0 1-1.118-.124l1.5-13.5a.56.56 0 0 1 .621-.497",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M2.063 6.75c0-.31.251-.562.562-.562h13.5a.562.562 0 1 1 0 1.125h-13.5a.563.563 0 0 1-.562-.563M1.313 11.25c0-.31.251-.562.562-.562h13.5a.562.562 0 1 1 0 1.124h-13.5a.56.56 0 0 1-.562-.562",
    clipRule: "evenodd"
  })));
};
export default SvgIconHastag;